import { render, staticRenderFns } from "./optionsdialog.vue?vue&type=template&id=45cc4b23&scoped=true"
import script from "./optionsdialog.vue?vue&type=script&lang=js"
export * from "./optionsdialog.vue?vue&type=script&lang=js"
import style0 from "./optionsdialog.vue?vue&type=style&index=0&id=45cc4b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc4b23",
  null
  
)

export default component.exports